import React, { useEffect, useRef } from 'react';
import UiWidget from './UiWidget';
import { Widget } from '../hooks/integrations/externalIntegrationTypes';
import './UiWidgetModal.scss';
import { ModalHeader, ModalContent, WhiteModal } from '@upsales/components';

interface UiWidgetModalProps {
	widget: Widget;
	onClose: () => void;
}

const UiWidgetModal = ({ widget, onClose }: UiWidgetModalProps) => {
	const modalRef = useRef<HTMLDialogElement>(null);

	useEffect(() => {
		const dialog = modalRef.current;
		if (dialog) {
			dialog.showModal();

			const handleClick = (event: MouseEvent) => {
				if (event.target === dialog) {
					dialog.close();
					onClose();
				}
			};
			dialog.addEventListener('click', handleClick);

			return () => {
				dialog.removeEventListener('click', handleClick);
			};
		}
	}, []);

	return (
		<dialog ref={modalRef} className="UiWidgetModal">
			<WhiteModal headerAtTop>
				<ModalHeader title={widget.name} onClose={onClose} />
				<ModalContent>
					<UiWidget widget={widget} />
				</ModalContent>
			</WhiteModal>
		</dialog>
	);
};

export default UiWidgetModal;
